import React from 'react';

const EtapaContext = React.createContext();

export default EtapaContext;
